import React, { useRef, useState, useEffect } from 'react';
import './distance.scss';
import Information from '../Information/Information';
import DraggableCustom from '../DraggableCustom/DraggableCustom';
import Marker from '../../interfaces/Marker';
import { calcTravelledDistance } from '../../utils';

interface IProps {
    steps: number;
    markers: Marker[],
    width: number;
    information: any;
    _handleDraggableOnStop: any;
}

const minSteps = 5;

export const createpoints = (steps: number = 4, markers: Marker[]) => {
        
    const points: number[] = [];        
    let acumulateDistance = 0;
    
    let travelledDistance = calcTravelledDistance(markers);  
    let interval = travelledDistance/steps;
    
    for(let i = 0; i<=steps; i++){
        points.push(acumulateDistance);
        acumulateDistance += interval;
    }

    return points;
}

const Distance = ({steps = minSteps, markers, _handleDraggableOnStop, width, information}: IProps) => {
    
    const [points, setPoints] = useState<any[]>([]);
    const [widthCanva, setWidthCanva] = useState<number>();
    const barRef = useRef<any>(null);

    const canvasRef = useRef(null);

    useEffect(() => {
        setPoints(createpoints(steps, markers)); 
        setWidthCanva(width - 110); // TO-DO 
    }, [markers, width]);

    useEffect(() => {
        initCanva();
    }, [widthCanva, points]);

    const initCanva = () => {
        if(canvasRef && canvasRef.current){
            const canvas: any = canvasRef.current;
            const context: any = canvas.getContext('2d');

            draw(context, markers);
        }
    }

    const draw = (ctx, markers: Marker[]) => {
        ctx.clearRect(0, 0, barRef.current.clientWidth, 26);

        const travelledDistance = calcTravelledDistance(markers);
        let x = 0;
        let acumulateDistance = 0;

        if(markers.length === 0){
            
            ctx.fillStyle = '#E5E5E5';
            ctx.fillRect(x, 0, barRef.current.clientWidth, 150);       
            
        }

        for(let index = 1; index<markers.length; index++){
            const marker = markers[index];
                
            const {id, levelColor = '#000000', distance = 0} = marker;  
            acumulateDistance += distance;
            const width = (acumulateDistance*barRef.current.clientWidth)/travelledDistance;
            
            ctx.fillStyle = levelColor;
            ctx.fillRect(x, 0, width, 150);       
            x = width;
        } 
    }

    const _renderpoints = (unity: any) => {

        return (
            <>                
                {points.map((point, index) => {
                    return (
                        <li key={index} className="item">
                            {(markers.length == 0 ? '--' : point.toFixed(1)).concat(unity)} 
                        </li>
                        )
                })}
            </>   
        )
    }

    return (
        <div className="widget-gmaps-wrapper-bar">

            { <Information markers={markers} information={information}/>}

            <div style={{padding: '0 15px'}} className="d-flex">
                <div>
                    <i className="fas fa-location cursor-i"></i>
                </div>

                <div className="container-bar">                

                    <div className="bar" ref={barRef}>
                                
                        <canvas ref={canvasRef} width={widthCanva} height={26}/>
                        
                        <DraggableCustom
                            _handleDraggableOnStop={_handleDraggableOnStop}                             
                            barRef={barRef}
                            width={width}
                            markers={markers}/>
                    </div>
                    
                    <ul className="xPoints">
                        {_renderpoints('Km')}
                    </ul>
                </div>

                <div>
                    <i className="far fa-flag-checkered cursor-i"></i>
                </div>
            </div>
        </div>
    );
}

export default Distance;

